
import { useState } from "react";
import { MapPin } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Regions } from "./components/Regions";
import { Organizations } from "./components/Organizations";
import { Sites } from "./components/Sites";

const LocationsPage = () => {
  const [activeTab, setActiveTab] = useState("regions");

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <MapPin className="h-6 w-6 text-primary" />
          <h1 className="text-3xl font-bold tracking-tight">Location Management</h1>
        </div>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Location Hierarchy</CardTitle>
        </CardHeader>
        <CardContent>
          <Tabs value={activeTab} onValueChange={setActiveTab}>
            <TabsList>
              <TabsTrigger value="regions">Regions</TabsTrigger>
              <TabsTrigger value="organizations">Organizations</TabsTrigger>
              <TabsTrigger value="sites">Sites</TabsTrigger>
            </TabsList>
            <TabsContent value="regions">
              <Regions />
            </TabsContent>
            <TabsContent value="organizations">
              <Organizations />
            </TabsContent>
            <TabsContent value="sites">
              <Sites />
            </TabsContent>
          </Tabs>
        </CardContent>
      </Card>
    </div>
  );
};

export default LocationsPage;
